import { render, staticRenderFns } from "./StudentProfile.vue?vue&type=template&id=0cd96caa&scoped=true"
import script from "./StudentProfile.vue?vue&type=script&lang=js"
export * from "./StudentProfile.vue?vue&type=script&lang=js"
import style0 from "./StudentProfile.vue?vue&type=style&index=0&id=0cd96caa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd96caa",
  null
  
)

export default component.exports